<template>
  <div style="display: flex; align-items:center" v-show="!isLoading">
    <div>
      <mu-icon-button class="notificationBtn" style="padding-top: 10px;" @click.native="visible = !visible"
        :icon="icon" />
      <img v-if="showIndicator && newNotifications" class="newIndicator" src='~assets/indicator-dot.png' />
    </div>
    <mu-card id="notifications" v-if="visible" v-on-clickaway="away">
      <mu-card-header titleClass="blueTitle notificationTitle" :class="{ 'newNotifs': newNotifications }"
        :title="$t('message.notificationHeaderText')" style="padding: 10px 0 0 0;">
        <div v-if="newNotifications" class="readAll" @click="markAllRead()">
          <span>Mark all read</span>
        </div>
      </mu-card-header>
      <div class="notificationsEmpty" v-if="!newNotifications">
        <mu-icon value="notifications_none" size="80" color="#a8abb9" />
        <p>You haven't received any new notifications yet</p>
      </div>
      <div v-if="newNotifications" id="notificationScroller" class="scrollable"
        style="overflow: auto; -webkit-overflow-scrolling: touch">
        <mu-list>
          <mu-list-item v-for="(item, index) in notifications" :key="'n-' + index" :title="generateText(item)"
            @click.native="markReadAndGo(item)"
            :titleClass="{ notificationText: item.isViewed === true, notificationTextNew: item.isViewed === false }"
            :class="{ notificationTextNewBg: item.isViewed === null }">
            <div v-if="item.user" slot="left">
              <mu-avatar v-if="item.user.profile_thumb" :src="item.user.profile_thumb" color="white"
                backgroundColor="#E9E9E8" class="notificationAvatar" />
              <mu-avatar v-else color="black" backgroundColor="#E9E9E8"
                class="notificationAvatar">{{ item.user.firstname.substring(0, 1) }}</mu-avatar>
            </div>

            <div>
              <div :class="{ 'notificationTextNew': !item.isViewed }" v-text="formatDate(item.date_created)"
                style="font-family: 'Poppins',sans-serif;font-size: 16px;line-height: 1.4;font-weight: 400;"></div>
            </div>
            <!--            <div v-if="item.date_seen !== null">-->
            <!--              <div class="notificationText" v-text="formatDate(item.date_created)"></div>-->
            <!--            </div>-->
          </mu-list-item>
        </mu-list>
        <mu-content-block v-if="isAppending" align="center">
          <mu-circular-progress :size="32"></mu-circular-progress>
        </mu-content-block>
        <div v-if="!notificationEndedFromServer" class="wrapBtn">
          <mu-flat-button class="showMore" label="Show more" @click="showMore()"></mu-flat-button>
        </div>
        <!-- <div v-if="!isAppending" ref="detector"></div> -->

      </div>
    </mu-card>
  </div>
</template>
<script>

import { directive as onClickaway } from 'vue-clickaway';
import pusher from '../../helpers/PusherManager'
import NotificationApi from '../../api/Notifications'
import ScrollManager from '../../helpers/ScrollManager'


import config from '../../config'
import Pusher from 'pusher-js'




export default {
  directives: {
    onClickaway: onClickaway,
  },
  name: 'notifications-panel',
  data() {
    return {
      page: 1,
      perPage: 15,
      icon: '',
      showIndicator: false,
      isLoading: true,
      isAppending: false,
      visible: false,
      scroller: null,
      notificationsModel: {
        notifications: [],
      },
      notifications: [],
      loadMoreCount: 5,
      skip: 0,
      notificationEndedFromServer: false,
    }
  },
  watch: {
    'visible': function () {
      let self = this;
      if (self.visible) {
        self.icon = "notifications"
        self.showIndicator = true
      }
      if (!self.visible) {
        self.icon = "notifications_none";

      }
      else {
        self.icon = "notifications";
        // NotificationApi.getNotifications()
        //   .then(function (response) {
        //     self.notifications = _.remove(response.data.notifications, function(n, index) {
        //       return index <= 4;
        //     })
        //     self.isLoading = false;
        //   });
      }
    }
  },
  mounted() {
    let self = this;
    let channel = pusher.subscribe('notification_' + self.$store.state.user.scope.user_id);
    channel.bind('notification_' + self.$store.state.user.scope.user_id, function (data) {
      self.icon = 'notifications'
      self.showIndicator = true
    });
  },
  created() {
    let self = this;
    NotificationApi.getNotifications()
      .then(function (response) {
        let isViewedArr = [];
        response.data.notifications.forEach(function (item) {
          isViewedArr.push(item.isViewed)
        })
        if (isViewedArr.includes(false)) {
          self.icon = 'notifications_active';
        } else {
          self.icon = 'notifications_none';

        }

        self.notifications = response.data.notifications.slice(0, 5);
        self.isLoading = false;
        self.showIndicator = true
      })
      .catch(function (error) {
        self.icon = 'notifications_none';
        self.showIndicator = false
      })
  },
  methods: {
    showMore() {
      let self = this;
      self.isAppending = true;
      self.loadMoreCount += 5;
      self.skip += 5;
      NotificationApi.getNotifications(self.skip)
        .then(function (response) {
          self.notifications = [...self.notifications, ...response.data.notifications];
          if (response.data.notifications.length < 5) self.notificationEndedFromServer = true;
        }).finally(() => self.isAppending = false)
    },
    markAllRead() {
      let self = this;
      self.notifications.forEach(function (item) {
        if (item.isViewed === false) {
          self.notificationsModel.notifications.push(item.id);
        }
      })
      let notificationIds = []
      self.notifications.forEach(notification => notificationIds.push(notification.notification_id))
      NotificationApi.markAsRead({ "notificationId": notificationIds })
        .then(function (response) {
        }).finally(() => {
          self.notifications = []
        })
      self.showMore()

    },
    away() {
      let self = this;
      self.visible = false;
    },
    formatDate(date) {
      return config.dateFormatting.fromNow(date)
    },
    routeTo(notification) {
      let self = this;
      switch (notification.type) {
        case 'answer':
          this.$router.push({
            path: '/questions/thread/' + notification.routesTo
          });
          self.visible = false;
          break;
        case 'follow':
          break;
      }
    },
    loadMore() {
      let self = this;
      if (self.data.count.totalCount > self.data.notifications.length) {
        self.isAppending = true;
        self.page += 1;
        NotificationApi.getNotifications(self.page, self.perPage)
          .then(function (response) {
            self.data.count = response.data.count;
            self.data.notifications.push.apply(self.data.notifications, response.data.notifications);
            self.isAppending = false;
          })
      }
    },
    markReadAndGo(notification) {
      let self = this;
      // Some notifications have no link target; still mark them read below.
      switch (notification.screenLinkProperties ? notification.screenLinkProperties.type : null) {
        case 'NONE':
        case 'HOME':
          self.$router.push({
            name: 'Dashboard',
          });
          break;
        case 'LIFESTYLE':
          self.$router.push({
            name: 'LifeStyle',
          });
          break;
        case 'COMMUNITY':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'RECENT':
              self.$router.push({
                name: 'QuestionsIndex',
              });
              break;
            case 'TRENDING':
              self.$router.push({
                path: '/questions?page=1&per_page=25&type=MOST_TRENDING',
              });
              break;
            case 'USEFUL':
              self.$router.push({
                path: '/questions?page=1&per_page=25&type=MOST_USEFUL',
              });
              break;
            case 'POST':
              self.$router.push({
                name: 'QuestionThread',
                params: {
                  id: notification.screenLinkProperties.id
                }
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'QuestionCreate',
              });
              break;
          }
          break;
        case 'EDUCATION':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
              self.$router.push({
                name: 'Dashboard',
              });
              break;
            case 'LESSON':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id
                }
              });
              break;
            case 'ACTION':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#action_points'
                }
              });
              break;
            case 'QUIZ':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#lessonQuiz'
                }
              });
              break;
            case 'DOWNLOADS':
              self.$router.push({
                name: 'Lessons',
                params: {
                  permalink: notification.screenLinkProperties.id + '#downloadsPanel'
                }
              });
              break;



          }
          break;
        case 'FOOD_DIARY':
          self.$router.push({
            name: 'ProfileFoodDiary',
          });
          break;
        case 'TRACKING':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'WEIGHT':
            case 'MOOD':
            case 'BLOOD_GLUCOSE':
            case 'MEDICATION':
            case 'SLEEP':
            case 'BLOOD_PRESSURE':
            case 'CHOLESTEROL':
            case 'INSULIN':
            case 'KETONES':
            case 'ACTIVITY':
              self.$router.push({
                path: '/dashboard#trackHealth',
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'AddProgress',
              });
              break;
          }
          break;
        case 'PROFILE':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
              self.$router.push({
                name: 'Profile',
                params: {
                  profileUrl: notification.screenLinkProperties.id
                }
              });
              break;
            case 'NEW':
              self.$router.push({
                name: 'Profile',
              });
              break;
          }
          break;
        case 'FAQ':
          self.$router.push({
            name: 'Faq',
          });
          break;
        case 'RECIPES':
          switch (notification.screenLinkProperties.subType) {
            case 'NONE':
            case 'HOME':
            case 'INSPIRE_ME':
              self.$router.push({
                name: 'RecipeIndex',
              });
              break;
            case 'FAVOURITES':
              self.$router.push({
                name: 'RecipeFavorites',
              });
              break;
            case 'CATEGORY':
              self.$router.push({
                name: 'recipes/bygroup?' + notification.screenLinkProperties.id,
              });
              break;
            case 'RECIPE':
              self.$router.push({
                name: 'RecipeDetail',
                params: {
                  id: notification.screenLinkProperties.id
                }
              });
              break;
          }
          break;
        case 'DOWNLOADS_AND_RESOURCES':
          self.$router.push({
            name: 'Downloads',
          });
          break;
        case 'SETTINGS':
          self.$router.push({
            name: 'SettingsGeneral',
          });
          break;
      }
      NotificationApi.markAsRead({ "notificationId": [notification.notification_id] })
        .then(function (response) {
        }).finally(() => {
          self.notifications = self.notifications.filter(not => not != notification)
        })
      self.visible = false;
    },
    generateText(item) {
      let name = item.user ? item.user.display_name ? item.user.display_name : item.user.firstname : ''
      name = name ? name[0].toUpperCase() + name.substring(1) : ''
      return `${name} ${item.phrase} ${item.thread_title}`
    }
  },
  computed: {
    newNotifications() {
      let self = this;
      if (!self.notifications.length) {
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>
<style>
#notifications {
  position: fixed;
  top: 64px;
  z-index: 9999;
  width: 392px;
  max-height: 370px;
  right: 24px;
  padding: 10px 14px 16px;
  border-radius: 13px;
  background-color: #fff;
  box-shadow:0 4px 9px 1px rgb(0 0 0 / 41%);
}

.notificationBtn {
  transition: .2s ease-in-out;
  border-radius: 30px !important;
  width: 60px !important;
}

.notificationBtn:hover {
  background-color: hsla(0, 0%, 100%, .14);
}

.notificationBtn i {
  font-family: 'Material Icons Round';
}

#notifications .newNotifs {
  display: flex;
  justify-content: space-around;
}

.notificationsEmpty {
  padding: 10px 0;
  text-align: center;
}

.notificationsEmpty i {
  transform: scale(1.3);
}

.notificationsEmpty p {
  color: #000;
  font-size: 1rem;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
}

.readAll span {
  font-family: 'Poppins', sans-serif;
  color: #0179d5;
  line-height: 1.4;
  text-decoration: underline;
  cursor: pointer;
  vertical-align: middle;
  font-size: 1rem;
}

.notificationTextNewBg {
  background-color: rgba(190, 201, 213, .2);
  border-radius: 8px;
}

.notificationTextNew {
  font-weight: 500 !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  line-height: 1.4;
}

.notificationAvatar,
.notificationAvatar img {
  border-radius: 8px !important;
}

.notificationTitle {
  margin-bottom: 10px;
  font-family: 'Poppins', sans-serif;
  color: #0176d0 !important;
  font-size: 1.2rem !important;
  line-height: 1.4;
  font-weight: 600 !important;
}

.mu-icon-button .mu-icon {
  font-size: 28px;
}

.blue {
  background: #e9e9e9 !important;
  color: #0179d5 !important;
}

#notifications .mu-item.show-left {
  padding-left: 72px !important;
}

.scrollable {
  height: 200px;
}

@media (max-width: 800px) {
  .scrollable {
    height: calc(100% - 106px);
  }

  #notifications {
    position: fixed;
    left: 0;
    right: 0 !important;
    width: 100% !important;
    height: calc(100% - 66px);
  }
}

#notificationScroller .wrapBtn {
  padding: 0 16px;
  margin-top: 20px;
}

#notificationScroller .wrapBtn .showMore {
  background-color: rgba(190, 201, 213, .2);
  color: #0176d0;
  height: 40px;
  width: 100%;
  transition: .2s ease-in-out;
  font-family: 'Poppins', sans-serif;
  border-radius: 8px;
}

#notificationScroller .wrapBtn .showMore .mu-flat-button-label {
  font-size: 1rem;
  text-transform: none;
  font-weight: 500;
  transition: .2s ease-in-out;
}

#notificationScroller .wrapBtn .showMore:hover .mu-flat-button-label {
  -webkit-transform: translate(0, -2px);
  -ms-transform: translate(0, -2px);
  transform: translate(0, -2px);
}

#notificationScroller .wrapBtn .showMore:hover {
  box-shadow: 0 4px 12px 8px rgb(91 97 124 / 10%);
}

#notificationScroller .mu-item {
  padding-top: 10px;
  padding-bottom: 10px;
}

div#notificationScroller .mu-item-right {
  width: 100px;
  text-align: right;
  justify-content: flex-end;
  padding-right: 8px;
}

/**
    #notifications .mu-card-header {
      border-bottom: 1px dashed #e3e3e3;
    }

    **/

.isEmpty {
  font-weight: 300;
  color: #9b9b9b !important;
  background-color: #fafafa !important;
}

.bellTilted {
  color: #d8d8d8;
  margin-bottom: 34px;
  transform: rotate(20deg);
  -webkit-transform: rotate(20deg);
  -moz-transform: rotate(20deg);
  -ms-transform: rotate(20deg);
}

.newIndicator {
  position: absolute;
  top: 36px;
  right: 60px;
}
</style>



// WEBPACK FOOTER //
// Notifications.vue?034c7d6e